import { Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { useOwner } from '../hook/useOwner';
import { useEffect } from 'react';
import usePermission from '../../../hooks/usePermission';

const { Option } = Select;

export default function AddOwner({ dataFlowInfo }) {
    const { t } = useTranslation();
    const {
        owners,
        ownersDepartment,
        getOwners,
        getOwnersDepartment,
        updateOwner,
        deleteOwner,
    } = useOwner(dataFlowInfo);

    const { isAuditor } = usePermission();

    useEffect(() => {
        getOwners();
        getOwnersDepartment();
    }, [getOwners, getOwnersDepartment]);

    return (
        <div className="col-span-1 bg-white h-max rounded-xl p-4 py-6 my-4">
            <div
                className="text-[17px] font-semibold pb-2"
                style={{ borderBottom: '3px solid #F4F6FC' }}
            >
                {t('Data Owner Data Flow')}
            </div>
            <div className="mt-2">
                <label className="font-semibold">
                    {t('Specify the name of the owner of this Data Flow data')}
                </label>
                <Select
                    disabled={isAuditor}
                    className="mt-2"
                    style={{ width: '100%' }}
                    size="large"
                    mode="multiple"
                    placeholder={t('Select Data Owner')}
                    showSearch
                    optionLabelProp="label"
                    filterOption={(input, option) =>
                        (option?.email + ' ' + option?.label)
                            ?.toLowerCase()
                            .includes(input.toLowerCase())
                    }
                    value={owners}
                    onSelect={updateOwner}
                    onDeselect={deleteOwner}
                >
                    {ownersDepartment?.map((item) => (
                        <Option
                            key={item?.userId}
                            value={item?.userId}
                            label={item?.fullName}
                            email={item?.email}
                        >
                            <div aria-label={item?.fullName}>
                                <div>{item?.fullName}</div>
                                <div className="text-[#65707A]">
                                    {item?.email}
                                </div>
                            </div>
                        </Option>
                    ))}
                </Select>
            </div>
        </div>
    );
}
